import colorsVars from 'styles/colors.module.scss';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { Modal } from 'components/DesignSystem/Modal';
import { ChangePasswordModal } from 'components/Settings/Components/UserProfile/components/ChangePassword/ChangePasswordModal/changePasswordModal';
import classes from 'components/Settings/Components/UserProfile/components/userProfile.module.scss';

const { linkColor } = colorsVars;

export const ChangePassword = ({ setModalShow, modalShow, userEmail }) => (
    <div className={classes.adminActionWrapper}>
        <Icon name={'lock-white'} size={'1.5rem'} color={linkColor} />
        <span className={classes.changePasswordTitle} onClick={() => setModalShow(true)}>
            Change Password
        </span>

        <ChangePasswordModal open={modalShow} onClose={() => setModalShow(false)} userEmail={userEmail} />
    </div>
);
